import lockScroll from '../__utils/lockScroll';
import breakpoints from '../__utils/breakpoints';

const HEADER_ACTIVE_CLASS = 'mobile-open';
const BTN_ACTIVE_CLASS = 'open';
const SUBNAV_ACTIVE_CLASS = 'subnav-open';
const HEADER_SUBNAV_CLASS = 'header-subnav';
const HEADER_TRANSPARENT_CLASS = 'main-header--inverted';
const HEADER_FIXED_CLASS = 'main-header--fixed';
const HEADER_SHADOW_CLASS = 'main-header--shadow';

const header = document.querySelector('.main-header');
const { body } = document;

const headerHandler = {
    trigger: null,
    parentLinks: [],
    backButtons: [],

    cacheDOM() {
        this.trigger = header.querySelector('.js-mobile-header-trigger');
        this.parentLinks = header.querySelectorAll(
            '.main-header__nav > .menu > .menu-item-type-post_type > a'
        );
        this.backButtons = header.querySelectorAll('.main-header__mobile-back');
    },

    bindEvents() {
        this.trigger &&
            this.trigger.addEventListener('click', () => this.toggleNav());

        this.parentLinks.length &&
            this.parentLinks.forEach((el) =>
                el.addEventListener('click', this.toggleSubNav)
            );

        this.backButtons.length &&
            this.backButtons.forEach((el) =>
                el.addEventListener('click', this.backButtonHandler)
            );
    },

    toggleNav() {
        if (header.classList.contains(HEADER_ACTIVE_CLASS)) {
            header.classList.remove(HEADER_ACTIVE_CLASS);
            this.trigger.classList.remove(BTN_ACTIVE_CLASS);
            lockScroll.unlock();
            body.classList.remove('overlayed');
        } else {
            header.classList.add(HEADER_ACTIVE_CLASS);
            this.trigger.classList.add(BTN_ACTIVE_CLASS);
            lockScroll.lock();
            body.classList.add('overlayed');
        }
    },

    backButtonHandler(e) {
        e.target.closest('.mega-menu-wrapper').previousElementSibling.click();
    },

    toggleSubNav(e) {
        e.preventDefault();
        const _this = e.target;

        if (_this.classList.contains(SUBNAV_ACTIVE_CLASS)) {
            _this.classList.remove(SUBNAV_ACTIVE_CLASS);

            if (breakpoints.lgMin.matches) {
                body.classList.remove('overlayed');
                header.classList.remove(HEADER_SUBNAV_CLASS);
                lockScroll.unlock();
            }
        } else {
            if (breakpoints.lgMin.matches) {
                headerHandler.parentLinks.forEach((el) =>
                    el.classList.remove(SUBNAV_ACTIVE_CLASS)
                );
                body.classList.add('overlayed');
                header.classList.add(HEADER_SUBNAV_CLASS);
                lockScroll.lock();
            }
            _this.classList.add(SUBNAV_ACTIVE_CLASS);
        }
    },

    hideOutSideClick(e) {
        if (breakpoints.mobileMax.matches) {
            return;
        }

        if (!header.contains(e.target)) {
            if (header.classList.contains(HEADER_ACTIVE_CLASS)) {
                headerHandler.toggleNav();
            } else if (header.classList.contains(HEADER_SUBNAV_CLASS)) {
                headerHandler.parentLinks.forEach((el) =>
                    el.classList.remove(SUBNAV_ACTIVE_CLASS)
                );
                body.classList.remove('overlayed');
                header.classList.remove(HEADER_SUBNAV_CLASS);
                lockScroll.unlock();
            }
        }
    },

    breakpointChange(e) {
        const activeLink = header.querySelector(`.${SUBNAV_ACTIVE_CLASS}`);

        if (!e.matches && header.classList.contains(HEADER_ACTIVE_CLASS)) {
            headerHandler.toggleNav();

            activeLink && activeLink.click();
        } else if (
            e.matches &&
            header.classList.contains(HEADER_SUBNAV_CLASS) &&
            activeLink
        ) {
            body.classList.remove('overlayed');
            header.classList.remove(HEADER_SUBNAV_CLASS);
            lockScroll.unlock();
            activeLink.click();
        }
    },

    transparentStateHandler() {
        if (!header) {
            return;
        }
        if (window.scrollY) {
            header.classList.add(HEADER_SHADOW_CLASS);
            header.classList.contains(HEADER_FIXED_CLASS) &&
                header.classList.remove(HEADER_TRANSPARENT_CLASS);
        } else {
            header.classList.remove(HEADER_SHADOW_CLASS);
            header.classList.contains(HEADER_FIXED_CLASS) &&
                header.classList.add(HEADER_TRANSPARENT_CLASS);
        }
    },

    init() {
        if (!header) {
            return;
        }

        this.cacheDOM();
        this.bindEvents();

        this.transparentStateHandler();

        if (breakpoints.lgMax.addListener) {
            breakpoints.lgMax.addListener((e) => this.breakpointChange(e));
        } else {
            breakpoints.lgMax.addEventListener('change', (e) =>
                this.breakpointChange(e)
            );
        }
    },
};

export default headerHandler;
